import React from 'react';

import { ReactComponent as Alert } from './alert.svg';

function AlertIcon() {
  return <Alert style={{ verticalAlign: 'middle' }} />;
}

export default AlertIcon;
